<div class="stock-initial-create">
  <div class="stock-initial-create__content">
    <div class="stock-initial-create__layout">
      <div class="stock-initial-create__header">
        <div class="stock-initial-create__heading">
          <h1 class="page-title">Create Stock Adjustment</h1>
          <p class="page-subtitle">Apply an initial, increase, or decrease adjustment for a material in a warehouse.</p>
        </div>
        <div class="stock-initial-create__actions">
          <app-button type="button" variant="secondary" (click)="goBack()">Back</app-button>
          <app-button type="button" [disabled]="isSaving || form.invalid" (click)="save()"
            >{{ isSaving ? "Saving..." : "Create Adjustment" }}</app-button
          >
        </div>
      </div>

      <app-card>
        <form [formGroup]="form" class="stock-initial-create__form">
          <div class="stock-initial-create__form-grid">
            <div class="stock-initial-create__form-field">
              <label for="stock-pages-create-stockinitialadjustmentcreatepage-field-1" class="stock-initial-create__form-label"
                >Material</label
              >
              <app-autocomplete
                [prefetchOnInit]="true"
                [options]="materialOptions"
                [minLength]="1"
                [debounceMs]="300"
                placeholder="Search material..."
                (searchChange)="searchMaterials($event)"
                (selectionChange)="onMaterialChange($event)"></app-autocomplete>
            </div>

            <div class="stock-initial-create__form-field">
              <label for="stock-pages-create-stockinitialadjustmentcreatepage-field-2" class="stock-initial-create__form-label"
                >Warehouse</label
              >
              <app-autocomplete
                [prefetchOnInit]="true"
                [options]="warehouseOptions"
                [minLength]="1"
                [debounceMs]="300"
                placeholder="Search warehouse..."
                (searchChange)="searchWarehouses($event)"
                (selectionChange)="onWarehouseChange($event)"></app-autocomplete>
            </div>
          </div>

          <div class="stock-initial-create__form-grid">
            <div class="stock-initial-create__form-field">
              <label for="stock-pages-create-stockinitialadjustmentcreatepage-field-3" class="stock-initial-create__form-label"
                >Adjustment Type</label
              >
              <select class="stock-initial-create__form-input stock-initial-create__form-select" formControlName="adjustmentType">
                @for (option of adjustmentTypeOptions; track option) {
                <option [value]="option">{{ option }}</option>
                }
              </select>
            </div>

            <div class="stock-initial-create__form-field">
              <label for="stock-pages-create-stockinitialadjustmentcreatepage-field-4" class="stock-initial-create__form-label"
                >Quantity</label
              >
              <input type="number" min="1" appQtyInput class="stock-initial-create__form-input" formControlName="qty" />
            </div>
          </div>

          <div class="stock-initial-create__form-field">
            <p class="stock-initial-create__form-hint">
              Use a positive quantity. The selected adjustment type determines whether stock is added or reduced.
            </p>
          </div>

          <div class="stock-initial-create__form-field">
            <label for="stock-pages-create-stockinitialadjustmentcreatepage-field-5" class="stock-initial-create__form-label"
              >Note</label
            >
            <app-rich-text-editor formControlName="note" placeholder="Write adjustment note..."></app-rich-text-editor>
          </div>
        </form>
      </app-card>
    </div>
  </div>
</div>
